import { CurrentPositionType } from './reducer';

export enum LocationActionType {
  SET_TRACK_CURRENT_POSITION = `SET_TRACK_CURRENT_POSITION`,
}

export interface SetTrackCurrentPositionAction {
  type: LocationActionType.SET_TRACK_CURRENT_POSITION;
  payload: CurrentPositionType;
}

export type LocationActions = SetTrackCurrentPositionAction;
